// =============================================================================
// CẤU HÌNH ĐỘNG DO ADMIN NHẬP, lưu chung trong bảng `qcv_score_infos`.
//
// TẠI SAO dùng lại bảng bảng-điểm: bảng này đã có sẵn cột `type`, `code`,
// `description`, `season_id` + đủ API CRUD (/api/v1/qcvInfo/...) và đã được
// AppLayout tải sẵn cho toàn app. Nhờ vậy thêm một mục cấu hình mới KHÔNG cần
// đổi model/migrate/deploy lại backend.
//
// Các dòng cấu hình mang `type = 'config'` để tách hẳn khỏi dòng tính điểm
// (`type = 'qcv'`). Mọi nơi chấm điểm đều đã lọc theo type hoặc dò theo `code`
// dạng "1.1"/"q1" nên không thể lẫn với mã cấu hình.
// =============================================================================

export const QCV_CONFIG_TYPE = 'config';

export const QCV_CONFIG_CODE = {
  // Link folder Google Drive tài liệu của Ban tổ chức - hiện thành 1 nút ở màn
  // Bình chọn, DÙNG CHUNG cho mọi ứng viên (không phải link theo từng người).
  BTC_DRIVE_URL: 'btc_drive_url',
};

// Lọc ra các dòng tính điểm thật (dùng cho màn Cấu hình Bảng tính điểm) để dòng
// cấu hình không bị hiện lẫn vào bảng điểm.
export const isQcvScoreRow = (row) => row?.type !== QCV_CONFIG_TYPE;

// Bản ghi cấu hình theo code (có cả id -> dùng để update/xoá).
export const findQcvConfig = (scoreInformationList, code) =>
  (scoreInformationList || []).find(
    (e) => e?.type === QCV_CONFIG_TYPE && e?.code === code
  ) || null;

// Giá trị cấu hình (lưu ở cột `description`), đã trim. '' = chưa cấu hình.
export const getQcvConfig = (scoreInformationList, code) =>
  (findQcvConfig(scoreInformationList, code)?.description || '').trim();

// Chỉ nhận link http/https để nút bấm không bao giờ dẫn tới đường dẫn rác.
export const isHttpUrl = (value) => /^https?:\/\/\S+$/i.test((value || '').trim());

// Dựng payload gửi lên API cho 1 mục cấu hình.
export const buildQcvConfigPayload = ({ seasonId, code, value, existing }) => ({
  ...(existing?.id ? { id: existing.id } : {}),
  seasonId,
  type: QCV_CONFIG_TYPE,
  code,
  description: (value || '').trim(),
  // Bảng dùng chung với bảng điểm nên vẫn phải có stt/value; dòng cấu hình
  // không dùng tới 2 cột này.
  stt: existing?.stt ?? 0,
  value: existing?.value ?? 0,
});
